// extracted by mini-css-extract-plugin
export default {"container":"ColorInput_container__fQV+Y","inputBaseStyle":"ColorInput_inputBaseStyle__2uoMX","colorInputLabel":"ColorInput_colorInputLabel__NR4o1"};